import React from 'react';
import { Participant } from '@carlito/shared-ui';
import cn from 'classnames';
import { IoPersonCircleOutline, IoCloseCircleOutline, IoAddCircleOutline } from 'react-icons/io5';

type GuestChipProps = {
  participant: Participant;
  isSelected?: boolean;
  onClick: () => void;
};

export function BookitoGuestChip({ participant, isSelected, onClick }: GuestChipProps) {
  return (
    <div
      onClick={onClick}
      className={cn(' mx-0.5 my-1 flex cursor-pointer items-center border rounded-full px-1 py-1', {
        'bg-light-default border-primary-default': isSelected,
        'bg-transparent border-gray-500': !isSelected,
      })}
    >
      <div className="bg-gray-200 rounded-full">
        <IoPersonCircleOutline className="h-5 w-5 text-gray-600" />
      </div>
      <span className="mx-1 text-sm">{participant.displayName}</span>
      {isSelected ? (
        <IoCloseCircleOutline className="h-5 w-5 text-red-500" />
      ) : (
        <IoAddCircleOutline className="h-5 w-5 text-green-500" />
      )}
    </div>
  );
}
